export default (price, cents = false) => {
  if (!price) {
    return null;
  }
  const formattedPrice = price.toLocaleString('nl-NL', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: cents ? 2 : 0,
    maximumFractionDigits: cents ? 2 : 0,
  });
  if (cents) {
    return formattedPrice;
  }
  return `${formattedPrice},-`;
};
